export const GET_MESSAGES_PENDING = 'GET_MESSAGES_PENDING'
export const GET_MESSAGES_SUCCESSFUL = 'GET_MESSAGES_SUCCESSFUL'
export const GET_MESSAGES_ERROR = 'GET_MESSAGES_ERROR'
export const SAVE_MESSAGE_PENDING = 'SAVE_MESSAGE_PENDING'
export const SAVE_MESSAGE_SUCCESSFUL = 'SAVE_MESSAGE_SUCCESSFUL'
export const SAVE_MESSAGE_ERROR = 'SAVE_MESSAGE_ERROR'
export const ACCOUNTING = 'ACCOUNTING'
export const PARTS = 'PARTS'